import { FunctionComponent } from "react";

import useConfirmTransfer from "./useConfirmTransfer";
import LoadingScreen from "../general/loading-screen";
import PersonalDetails from "./screens/PersonalDetails";
import SpousalInfo from "./screens/SpousalInfo";
import MailingAddress from "./screens/MailingAddress";
import InitiateTransfer from "./screens/InitiateTransfer";
import {
  STEP_CONFIRM_TRANSFER_DETAILS,
  STEP_INITIATE_TRANSFER,
  STEP_IRA_OPEN_FORM,
  STEP_MAILING_ADDRESS,
  STEP_MARTIAL_INFO,
  STEP_PERSONAL_INFO,
} from "../../class/transferDetails";
import ConfirmTransferDetails from "./screens/ConfirmTransferDetails";
import IRAOpenForm from "./screens/IRAOpenForm";

const ConfirmTransfer: FunctionComponent = () => {
  const props = useConfirmTransfer();

  if (props.isLoading) {
    return <LoadingScreen loadingScreenMessage="" />;
  }

  switch (props.currentScreen) {
    case STEP_CONFIRM_TRANSFER_DETAILS:
      return <ConfirmTransferDetails {...props} />;
    case STEP_PERSONAL_INFO:
      return <PersonalDetails {...props} />;
    case STEP_MAILING_ADDRESS:
      return <MailingAddress {...props} />;
    case STEP_IRA_OPEN_FORM:
      return <IRAOpenForm {...props} />;
    case STEP_MARTIAL_INFO:
      return <SpousalInfo {...props} />;
    case STEP_INITIATE_TRANSFER:
      return <InitiateTransfer {...props} />;
    default:
      return <PersonalDetails {...props} />;
  }
};

export default ConfirmTransfer;
